<template>
    <div class="calendar">

        <FullCalendar 
            v-if="calendarOptions" 
            ref="fullCalendar" 
            :options="calendarOptions"
            />
        
        <!-- Añadir evento -->
        <el-dialog
            title="Añadir evento"
            :visible.sync="dialogAddEvent.open"
            width="30%"
            append-to-body>
            <span>Añadir evento</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogAddEvent.open = false">Cancelar</el-button>
                <el-button type="primary" @click="dialogAddEvent.open = false">Guardar</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import timeGridPlugin from '@fullcalendar/timegrid';
import esLocale from '@fullcalendar/core/locales/es';

export default {
    name: 'Calendar',
    components: {
        FullCalendar
    },
    data() {
        return {
            dialogAddEvent: {
                open: false
            },
            calendarOptions: null
        }
    },
    mounted() {
        this.calendarOptions = {
            themeSystem: 'standard',
            locale: esLocale,
            firstDay: 1,
            plugins: [ timeGridPlugin, dayGridPlugin, interactionPlugin ],
            headerToolbar: {
                left: 'prev,next today',
                center: 'title',
                right: 'dayGridMonth,timeGridWeek,timeGridDay'
            },
            initialView: 'dayGridMonth',
            dateClick: this.handleDateClick,
            editable: true,
            selectable: true,
            droppable: true,

            /* Eventos */
            select: this.handleDateSelect,
            eventClick: this.handleEventClick,
            //eventsSet: this.handleEvents
            eventAdd: this.handleEventAdd,
            eventChange: this.handleEventChange,
            eventRemove: this.handleEventRemove,
            datesSet: this.handleDateSet,
            
            events: [
                { title: 'event 1', start: '2021-03-01', backgroundColor: '#d63031', borderColor: '#d63031',
                    extendedProps: {
                        entidad: 'apkcontrato_apk', id: 21604019
                    }
                },
                { title: 'event 2', start: '2021-03-07', end: '2021-03-14', backgroundColor: '#F56C6C', borderColor: '#F56C6C', editable: false,
                    extendedProps: {
                        entidad: 'apkcontrato_apk', id: 21604019
                    }
                }
            ]
        }
    },
    methods: {
        handleDateClick(e) {
            
            this.dialogAddEvent.open = true
        },
        // Eliminar evento
        handleEventRemove(e) {
            console.log('handleEventRemove: ',e)
        },
        // Modificar evento
        handleEventChange(e) {
            console.log('handleEventChange: ',e)
        },
        // Añadir evento
        handleEventAdd(e) {
            console.log('handleEventAdd: ',e)
        },
        // Seleccionar un evento
        handleEventClick(e)  {
            e.jsEvent.preventDefault()

            // Abrir una nueva ventana
            this.$emit('openWindow', {
                entidad: e.event.extendedProps.entidad, 
                id: e.event.extendedProps.id
            })
        },
        // Seleccionar una fecha
        handleDateSelect(e) {
            console.log('handleDateSelect',e)
        },
        // Cambio de fecha
        handleDateSet(e) {
            console.log('handleDateSet')

            // Obtener eventos para una fecha concreta
            console.log('start: ',e.startStr)
            console.log('end: ',e.endStr)
            console.log('event: ',e.view.type)
        }

    }
}
</script>

<style lang="scss">
.calendar {
    padding: 0rem 0.5rem 0.5rem 0.5rem;
    display: flex;
    justify-content: space-between;
    .fc {
        flex-grow: 1;
        .fc-button {
            padding: 0.3em 0.85em;
            font-size: 0.85rem;
        }
    }
    h2.fc-toolbar-title {
        font-size: 1.4rem!important;
    }
}
</style>